import { createResource } from '@atlassian/react-resource-router';
import getData from './get-data/index.tsx';

const RESOURCE_TYPE_CSM_BASE_URL = 'CSM_SUPPORT_SITE_BASE_URL';

export const csmBaseUrlResource = createResource<string>({
	type: RESOURCE_TYPE_CSM_BASE_URL,
	getKey: () => 'csm-support-site-base-url',
	getData: async () => getData(),
	maxAge: 0,
});
